import React from 'react';
import ImageV2 from 'components_v2/common/ImageV2';
import s from './UsMainBattle.scss';
import { IMAGE_URL } from '../../../../constants';

const UsMainBattle = ({
  starCandidates,
  majority,
  electTotal,
  leadingPartyObj,
  totalWonSeats,
  isPrimeUserLayout,
}) => (
  <section className={`${s.uSMainBattleWrap}`}>
    <div className={`${s.partyInfoWrap} ${s.flex}`}>
      <div className={`${s.partyInfo} ${s.flex}`}>
        <div className={`${s.party} ${s.flex}`}>
          <div className={s.candiImage}>
            <ImageV2
              src={`${IMAGE_URL}${starCandidates?.Kamala?.img}.cms`}
              alt=""
            />
            <div
              className={`${s.partySymb} ${s.partyLogo}`}
              style={{ borderColor: starCandidates?.Kamala?.partyColor }}
            >
              <ImageV2
                src={`${IMAGE_URL}${starCandidates?.Kamala?.partyLogo}.cms`}
                alt=""
              />
            </div>
          </div>
          <div
            className={`${s.candiName} ${isPrimeUserLayout ? `candiName` : ``}`}
          >
            {starCandidates?.Kamala?.first} {starCandidates?.Kamala?.last}
          </div>
        </div>
        <div
          className={`${s.partySeats} ${s.pleft}`}
          style={{ color: starCandidates?.Kamala?.partyColor }}
        >
          {starCandidates?.Kamala?.electWon || '00'}
        </div>
      </div>

      <div className={`${s.partyInfo} ${s.flex}`}>
        <div
          className={`${s.partySeats} ${s.pright}`}
          style={{ color: starCandidates?.Donald?.partyColor }}
        >
          {starCandidates?.Donald?.electWon || '00'}
        </div>
        <div className={`${s.party} ${s.flex}`}>
          <div className={s.candiImage}>
            <ImageV2
              src={`${IMAGE_URL}${starCandidates?.Donald?.img}.cms`}
              alt=""
            />
            <div
              className={`${s.partySymb} ${s.partyLogo}`}
              style={{ borderColor: starCandidates?.Donald?.partyColor }}
            >
              <ImageV2
                src={`${IMAGE_URL}${starCandidates?.Donald?.partyLogo}.cms`}
                alt=""
              />
            </div>
          </div>
          <div
            className={`${s.candiName} ${isPrimeUserLayout ? `candiName` : ``}`}
          >
            {starCandidates?.Donald?.first} {starCandidates?.Donald?.last}
          </div>
        </div>
      </div>
    </div>
    <div className={s.majoBarWrap}>
      <div className={s.majoMark}>
        Majority: {majority}
        <i className={s.arrowIcon} />
      </div>
      <div
        className={s.leftBar}
        style={{
          background: starCandidates?.Kamala?.partyColor,
          width: `${
            electTotal > 0
              ? (starCandidates?.Kamala?.electWon || 0) / electTotal * 100
              : 0
          }%`,
        }}
      />
      <div
        className={s.rightBar}
        style={{
          background: starCandidates?.Donald?.partyColor,
          width: `${
            electTotal > 0
              ? (starCandidates?.Donald?.electWon || 0) / electTotal * 100
              : 0
          }%`,
        }}
      />
    </div>
    <div className={`${s.countingStatus} ${s.flex}`}>
      <span>
        E.V.: {totalWonSeats.electWon || 0}/{electTotal}
      </span>
      <span>
        {leadingPartyObj.party} {leadingPartyObj.text}
      </span>
    </div>
  </section>
);

// UsMainBattle.propTypes = {

// };
// UsMainBattle.defaultProps = {

// };

export default UsMainBattle;
